const STORAGE_KEY = "book-followup-appointment-project-context";

export interface FollowUpProjectContext {
  projectId: number;
  appointmentId?: number;
}

const isFollowUpProjectContext = (
  value: unknown
): value is FollowUpProjectContext => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const candidate = value as Record<string, unknown>;
  if (typeof candidate.projectId !== "number") {
    return false;
  }
  if (
    candidate.appointmentId !== undefined &&
    typeof candidate.appointmentId !== "number"
  ) {
    return false;
  }
  return true;
};

const safeSessionStorage = <T>(
  operation: (storage: Storage) => T
): T | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    return operation(window.sessionStorage);
  } catch {
    return undefined;
  }
};

export const setFollowUpProjectContext = (context: FollowUpProjectContext) => {
  safeSessionStorage((storage) =>
    storage.setItem(STORAGE_KEY, JSON.stringify(context))
  );
};

export const getFollowUpProjectContext = () => {
  const value = safeSessionStorage((storage) => storage.getItem(STORAGE_KEY));
  if (!value) {
    return undefined;
  }
  try {
    const parsed: unknown = JSON.parse(value);
    return isFollowUpProjectContext(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const clearFollowUpProjectContext = () => {
  safeSessionStorage((storage) => storage.removeItem(STORAGE_KEY));
};
